import { render, staticRenderFns } from "./newWiring.vue?vue&type=template&id=9e039732&scoped=true"
import script from "./newWiring.vue?vue&type=script&lang=js"
export * from "./newWiring.vue?vue&type=script&lang=js"
import style0 from "./newWiring.vue?vue&type=style&index=0&id=9e039732&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e039732",
  null
  
)

export default component.exports